var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { selectBalancingResource } from "../balancingSelectors/selectBalancingResources";
import { selectProductionResourceBuffAmount } from "./selectBuffsInfo";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
import { selectQuickSellProductsInfo } from "./selectQuickSellInfo";
import { selectSelectedBuildingRecipeBoostedAmount } from "./selectRecipeInfo";
import { selectStorageInfo } from "./selectStorageInfo";
export var selectSoldResourceMaxAmount = function (state, resourceId) {
    return selectInventoryResourceInfo(state, resourceId).amount;
};
export var selectSoldResourceMinAmount = function (state, resourceId) {
    var storageCapacity = selectStorageInfo(state);
    var nonCollectibleResource = selectQuickSellProductsInfo(state);
    if (nonCollectibleResource == undefined) {
        return Long.ZERO;
    }
    var soldResourceMaxValue = selectSoldResourceMaxAmount(state, resourceId);
    var nonCollectibleResourceAmount = Long.fromValue(nonCollectibleResource.amount);
    var nonCollectibleResourceBoostedAmount = selectSelectedBuildingRecipeBoostedAmount(state, nonCollectibleResourceAmount);
    var nonCollectibleResourceBuffAmount = selectProductionResourceBuffAmount(state, resourceId, nonCollectibleResourceAmount);
    var nonCollectibleResourceTotalAmount = nonCollectibleResourceAmount
        .add(nonCollectibleResourceBoostedAmount)
        .add(nonCollectibleResourceBuffAmount);
    return soldResourceMaxValue.add(nonCollectibleResourceTotalAmount).subtract(storageCapacity);
};
export var selectResourceData = function (state, resource) {
    var resourceProto = selectInventoryResourceInfo(state, resource);
    var resourceBalancing = selectBalancingResource(resource);
    return __assign({}, resourceProto, resourceBalancing, { amount: resourceProto.amount });
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectResourceInfo.ts
// module id = 287
// module chunks = 3